<template>
  <div>
    <ToastVue />
    <ConfirmDialog />
    <Dialog v-model:visible="showSharingDialog" modal header="Изменить роль" :style="{ width: '25rem' }">
      <div class="sharing-field">
        <label for="username">Тип доступа</label>
        <SelectVue v-model="sharingType" :options="sharingTypes || []" optionLabel="name" optionValue="value"
          style="width: 15rem; margin-left: auto" />
      </div>
      <div v-if="sharingType == 'link'" class="sharing-field">
        <label for="role">Роль</label>
        <SelectVue v-model="sharingRole" :options="sharingRoles || []" optionLabel="name" optionValue="value"
          style="width: 15rem; margin-left: auto" />
      </div>
      <!--<div class="sharing-field">
        <label for="expirationDate">Срок действия (необязательно)</label>
        <Calendar v-model="sharingExpirationDate" :show-icon="true" date-format="dd/mm/yy" placeholder="Срок действия"
          style="width: 15rem; margin-left: auto" />
      </div>-->
      <div class="sharing-buttons">
        <ButtonVue type="button" label="Отмена" severity="secondary" @click="showSharingDialog = false" />
        <ButtonVue type="button" label="Сохранить"
          @click="changeSharingType(currentFileId, sharingType, sharingRole, sharingExpirationDate)" />
      </div>
    </Dialog>
    <div class="flex" style="justify-content: center; gap: 10px">
      <InputText type="text" v-model="searchQuery" placeholder="Поиск" style="width: 100%" />
      <SelectVue v-model="filterSharingType" :options="sharingTypes || []" optionLabel="name" optionValue="value"
        placeholder="Тип доступа" style="width: 15rem; margin-left: auto" />
      <SelectVue v-model="filterFileType" :options="fileTypes || []" optionLabel="name" optionValue="value"
        placeholder="Тип файла" style="width: 15rem; margin-left: auto" />
      <ButtonVue @click="updatePermissions">
        <p v-if="!updateProcessing" style="margin: 0px">Обновить</p>
        <ProgressSpinner v-if="updateProcessing" style="width: 15px; height: 15px" strokeWidth="8" />
      </ButtonVue>
    </div>
    <Accordion :value="[]" multiple>
      <AccordionPanel v-for="(item, index) in paginatedList" :key="item.fileid" :value="index">
        <AccordionHeader>
          <div class="flex align-items-center">
            <p class="mr-2">{{ item.filename }}</p>
          </div>
          <div style="margin-left: auto; margin-right: 10px">
            <Tag :value="item.sharingtype == 'Restricted' ? 'Закрытый' : item.sharingtype == 'Link' ? 'Ссылка' : 'Открытый'
              " :severity="item.sharingtype == 'Restricted' ? 'danger' : 'info'"
              @click="openSharingDialog(item.fileid)" />
          </div>
        </AccordionHeader>
        <AccordionContent>
          <div class="flex" style="gap: 10px; align-items: center;">
            <div class="flex" style="flex-direction: column; align-items: flex-start;">
              <p>Тип доступа: {{ item.sharingtype == 'Restricted' ? 'Закрытый' : item.sharingtype == 'Link' ? 'Ссылка' :
                'Открытый' }}</p>
              <p>Владелец: {{ item.owner }}</p>
            </div>
            <div class="flex" style="gap: 10px; flex-direction: column; margin-left: auto; align-items: flex-end;">
              <ButtonVue :label="isCopied ? 'Скопировано' : 'Скопировать ссылку'" @click="copyLink(item.fileid)" />
              <ButtonVue label="Открыть в Google Drive" @click="openInGoogleDrive(item.fileid)" />
            </div>
          </div>

          <Accordion>
            <AccordionPanel value="add">
              <AccordionHeader>Добавить пользователя</AccordionHeader>
              <AccordionContent>
                <div class="flex" style="gap: 10px">
                  <FloatLabel class="label" variant="on">
                    <InputText type="text" v-model="newUser" style="width: 20rem" />
                    <label for="newUser">Введите email</label>
                  </FloatLabel>
                  <FloatLabel class="label" variant="on">
                    <SelectVue v-model="newUserRole" :options="roles || []" optionLabel="name" optionValue="value"
                      style="width: 15rem" />
                    <label for="newUserRole">Выберите роль</label>
                  </FloatLabel>
                  <FloatLabel class="label" variant="on">
                    <Calendar v-model="expirationDate" :show-icon="true" date-format="dd/mm/yy"
                      style="width: 15rem" />
                    <label for="expirationDate">Срок действия</label>
                  </FloatLabel>
                  <ButtonVue label="Добавить" @click="addUser(item.fileid)" />
                </div>
              </AccordionContent>
            </AccordionPanel>
            <AccordionPanel v-if="item.editors.length > 0" value="editors">
              <AccordionHeader>Редакторы</AccordionHeader>
              <AccordionContent>
                <div v-for="perm in item.editors" :key="perm" class="flex" style="gap: 10px">
                  <div class="flex" style="flex-direction: column; gap: 5px;">
                    <h3>{{ perm.includes('(до') ? perm.split('(до')[0] : perm }}</h3>
                    <small v-if="perm.includes('(до')" style="color: #666; margin-top: -20px;">
                      до {{ perm.split('(до')[1].replace(')', '') }}
                    </small>
                  </div>
                  <div class="flex" style="gap: 10px; align-items: center;">
                    <SelectVue
                      v-model="selectedRole"
                      :options="roles || []"
                      optionLabel="name"
                      optionValue="value"
                      placeholder="Выберите роль"
                      @change="
                        changeRole(item.fileid, perm.split('(до')[0].trim(), selectedRole, 'editor')
                      "
                    />
                  </div>
                </div>
              </AccordionContent>
            </AccordionPanel>
            <AccordionPanel v-if="item.commenters.length > 0" value="commenters">
              <AccordionHeader>Комментаторы</AccordionHeader>
              <AccordionContent>
                <div v-for="perm in item.commenters" :key="perm" class="flex" style="gap: 10px">
                  <div class="flex" style="flex-direction: column; gap: 5px;">
                    <h3>{{ perm.includes('(до') ? perm.split('(до')[0] : perm }}</h3>
                    <small v-if="perm.includes('(до')" style="color: #666; margin-top: -20px;">
                      до {{ perm.split('(до')[1].replace(')', '') }}
                    </small>
                  </div>
                  <div class="flex" style="gap: 10px; align-items: center;">
                    <SelectVue
                      v-model="selectedRole"
                      :options="roles || []"
                      optionLabel="name"
                      optionValue="value"
                      placeholder="Выберите роль"
                      @change="
                        changeRole(item.fileid, perm.split('(до')[0].trim(), selectedRole, 'commenter')
                      "
                    />
                    <Calendar v-model="roleExpirationDate" :show-icon="true" date-format="dd/mm/yy"
                      placeholder="Срок действия" style="width: 12rem" />
                  </div>
                </div>
              </AccordionContent>
            </AccordionPanel>
            <AccordionPanel v-if="item.viewers.length > 0" value="viewers">
              <AccordionHeader>Читатели</AccordionHeader>
              <AccordionContent>
                <div v-for="perm in item.viewers" :key="perm" class="flex" style="gap: 10px">
                  <div class="flex" style="flex-direction: column; gap: 5px;">
                    <h3>{{ perm.includes('(до') ? perm.split('(до')[0] : perm }}</h3>
                    <small v-if="perm.includes('(до')" style="color: #666; margin-top: -20px;">
                      до {{ perm.split('(до')[1].replace(')', '') }}
                    </small>
                  </div>
                  <div class="flex" style="gap: 10px; align-items: center;">
                    <SelectVue
                      v-model="selectedRole"
                      :options="roles || []"
                      optionLabel="name"
                      optionValue="value"
                      placeholder="Выберите роль"
                      @change="changeRole(item.fileid, perm.split('(до')[0].trim(), selectedRole, 'viewer')"
                    />
                    <Calendar v-model="roleExpirationDate" :show-icon="true" date-format="dd/mm/yy"
                      placeholder="Срок действия" style="width: 12rem" />
                  </div>
                </div>
              </AccordionContent>
            </AccordionPanel>
          </Accordion>
        </AccordionContent>
      </AccordionPanel>
    </Accordion>
    <Paginator v-model="currentPage" :total-records="totalRecords" :rows="10" @page="onPageChange" />
  </div>
</template>

<script setup>
import { ref, onMounted, computed, watch } from 'vue'
import Accordion from 'primevue/accordion'
import AccordionPanel from 'primevue/accordionpanel'
import AccordionHeader from 'primevue/accordionheader'
import AccordionContent from 'primevue/accordioncontent'
import InputText from 'primevue/inputtext'
import Tag from 'primevue/tag'
import ProgressSpinner from 'primevue/progressspinner'
import ConfirmDialog from 'primevue/confirmdialog'
import Dialog from 'primevue/dialog'
import Paginator from 'primevue/paginator';
import axios from 'axios'
import { useToast } from 'primevue/usetoast'
import { useConfirm } from 'primevue/useconfirm'
import Calendar from 'primevue/calendar'

const confirm = useConfirm()
const toast = useToast()
const list = ref([])
const searchQuery = ref('')
const debouncedSearchQuery = ref('')
const newUser = ref('')
const newUserRole = ref()
//const action = ref()
const selectedRole = ref()
const sharingType = ref()
const filterSharingType = ref()
const filterFileType = ref('Таблица')
const expirationDate = ref(null)
const sharingExpirationDate = ref(null)
const roleExpirationDate = ref(null)

const sharingTypes = ref([
  { name: 'Все', value: '' },
  { name: 'Открытый', value: 'open' },
  { name: 'Ссылка', value: 'link' },
  { name: 'Закрытый', value: 'restricted' }
])

const fileTypes = ref([
  { name: 'Все файлы', value: '' },
  { name: 'Документ', value: 'Документ' },
  { name: 'Таблица', value: 'Таблица' },
  { name: 'Презентация', value: 'Презентация' },
  { name: 'Рисунок', value: 'Рисунок' },
  { name: 'Форма', value: 'Форма' },
  { name: 'Папка', value: 'Папка' },
  { name: 'PDF', value: 'PDF' },
  { name: 'Изображения', value: 'Изображения' }
])
const roles = ref([
  { name: 'Редактор', value: 'editor' },
  { name: 'Комментатор', value: 'commenter' },
  { name: 'Читатель', value: 'viewer' },
  { name: 'Удалить', value: 'remove' }
])
const sharingRoles = ref([
  { name: 'Читатель', value: 'reader' },
  { name: 'Комментатор', value: 'commenter' },
  { name: 'Редактор', value: 'editor' }
])
const sharingRole = ref()
const updateProcessing = ref(false)
const processId = ref(null)
const showSharingDialog = ref(false)
const currentFileId = ref(null)
const isCopied = ref(false)
const currentPage = ref(0)
const totalRecords = ref(0)

// Дебаунс для поиска
let searchTimeout = null
watch(searchQuery, (newValue) => {
  clearTimeout(searchTimeout)
  searchTimeout = setTimeout(() => {
    debouncedSearchQuery.value = newValue
  }, 300)
})

const filteredList = computed(() => {
  let result = list.value

  // Фильтрация по поиску
  if (debouncedSearchQuery.value) {
    const searchLower = debouncedSearchQuery.value.toLowerCase()
    result = result.filter(item => {
      const filename = (item.filename || '').toLowerCase()
      if (filename.includes(searchLower)) return true

      // Проверяем только если есть пользователи
      const editors = item.editors || []
      const commenters = item.commenters || []
      const viewers = item.viewers || []

      return editors.some(editor => editor.toLowerCase().includes(searchLower)) ||
        commenters.some(commenter => commenter.toLowerCase().includes(searchLower)) ||
        viewers.some(viewer => viewer.toLowerCase().includes(searchLower))
    })
  }

  // Фильтрация по типу доступа
  if (filterSharingType.value) {
    const filterValue = filterSharingType.value.toLowerCase()
    result = result.filter(item => {
      const itemType = (item.sharingtype || '').toLowerCase()
      return itemType === filterValue
    })
  }

  // Фильтрация по типу файла
  if (filterFileType.value && filterFileType.value !== '') {
    result = result.filter(item => {
      const itemfiletype = item.filetype || ''
      if (filterFileType.value === 'image') {
        return itemfiletype.startsWith('image')
      }
      return itemfiletype === filterFileType.value
    })
  }

  return result
})

const paginatedList = computed(() => {
  // Возвращаем элементы для текущей страницы
  const startIndex = (currentPage.value) * 10
  const endIndex = startIndex + 10
  return filteredList.value.slice(startIndex, endIndex)
})

// Обновляем totalRecords при изменении filteredList
watch(filteredList, (newValue) => {
  totalRecords.value = newValue.length
}, { immediate: true })

// Сбрасываем страницу при изменении фильтров
watch([debouncedSearchQuery, filterSharingType, filterFileType], () => {
  currentPage.value = 0
})

onMounted(() => {
  getList()
})

const getList = async () => {
  const response = await axios.get(
    'https://ncht.bz/api/google/get-list-permissions'
  )
  list.value = response.data.data
}

const addUser = async fileid => {
  // Валидация даты истечения
  if (expirationDate.value) {
    const selectedDate = new Date(expirationDate.value);
    if (isNaN(selectedDate.getTime())) {
      toast.add({
        severity: 'error',
        summary: 'Ошибка',
        detail: 'Некорректный формат даты',
        life: 3000
      })
      return
    }
    const now = new Date();
    if (selectedDate <= now) {
      toast.add({
        severity: 'error',
        summary: 'Ошибка',
        detail: 'Дата истечения должна быть в будущем',
        life: 3000
      })
      return
    }
  }

  const response = await setPermissions(
    fileid,
    newUser.value,
    newUserRole.value,
    null,
    expirationDate.value
  )
  if (response && response.data.success) {
    toast.add({
      severity: 'success',
      summary: 'Успешно',
      detail: response.data.message,
      life: 3000
    })
    // Очищаем поля после успешного добавления
    newUser.value = ''
    newUserRole.value = null
    expirationDate.value = null
  } else if (response) {
    toast.add({
      severity: 'error',
      summary: 'Ошибка',
      detail: response.data.message,
      life: 3000
    })
  }
}

const changeRole = async (fileid, perm, newRole, oldRole) => {
  // Валидация даты истечения
  if (roleExpirationDate.value) {
    const selectedDate = new Date(roleExpirationDate.value);
    if (isNaN(selectedDate.getTime())) {
      toast.add({
        severity: 'error',
        summary: 'Ошибка',
        detail: 'Некорректный формат даты',
        life: 3000
      })
      return
    }
    const now = new Date();
    if (selectedDate <= now) {
      toast.add({
        severity: 'error',
        summary: 'Ошибка',
        detail: 'Дата истечения должна быть в будущем',
        life: 3000
      })
      return
    }
  }

  confirm.require({
    message: 'Вы уверены, что хотите изменить роль пользователя?',
    header: 'Подтверждение',
    icon: 'pi pi-exclamation-triangle',
    rejectProps: {
      label: 'Отмена',
      severity: 'secondary',
      outlined: true
    },
    acceptProps: {
      label: 'Сохранить'
    },
    accept: () => {
      setPermissions(fileid, perm, newRole, oldRole, roleExpirationDate.value)
      // Очищаем поля после применения
      selectedRole.value = null
      roleExpirationDate.value = null
    },
    reject: () => {
      toast.add({
        severity: 'error',
        summary: 'Отмена',
        detail: 'Вы отменили изменение роли пользователя',
        life: 3000
      })
    }
  })
}

const setPermissions = async (fileid, perm, action, oldRole = null, expirationDate = null) => {
  if (!fileid || !perm || !action) {
    toast.add({
      severity: 'error',
      summary: 'Ошибка',
      detail: 'Не все поля заполнены',
      life: 3000
    })
    return
  }
  if (!emailValidator(perm)) {
    toast.add({
      severity: 'error',
      summary: 'Ошибка',
      detail: 'Некорректный email',
      life: 3000
    })
    return
  }
  const response = await axios.post(
    'https://ncht.bz/api/google/set-permissions',
    {
      commands: [
        {
          fileId: fileid,
          userEmail: perm,
          role: action,
          oldRole: oldRole,
          expirationDate: expirationDate
        }
      ]
    }
  )
  if (response.data.success) {
    getList()
    toast.add({
      severity: 'success',
      summary: 'Успешно',
      detail: response.data.message,
      life: 3000
    })
  } else {
    toast.add({
      severity: 'error',
      summary: 'Ошибка',
      detail: response.data.message,
      life: 3000
    })
  }
}

const updatePermissions = async () => {
  const response = await axios.get(
    'https://ncht.bz/api/google/list-permissions'
  )
  if (response.data.success && processId.value == null) {
    processId.value = response.data.process_id
    updateProcessing.value = true
    toast.add({
      severity: 'info',
      summary: 'Обновление',
      detail: 'Обновление запущено, процесс займет несколько минут',
      life: 3000
    })
    setTimeout(checkUpdate, 1000)
  } else {
    toast.add({
      severity: 'error',
      summary: 'Ошибка',
      detail: response.data.message,
      life: 3000
    })
  }
}

const checkUpdate = async () => {
  if (!processId.value && processId.value != 0) {
    return
  }
  const response = await axios.get('https://ncht.bz/api/google/check-process', {
    params: {
      process_id: processId.value
    }
  })
  if (response.data.success && response.data.data.status == 'success') {
    getList()
    updateProcessing.value = false
    processId.value = null
    toast.add({
      severity: 'success',
      summary: 'Успешно',
      detail: 'Обновление завершено',
      life: 3000
    })
  } else if (response.data.success && response.data.data.status == 'error') {
    processId.value = null
    updateProcessing.value = false
    toast.add({
      severity: 'error',
      summary: 'Ошибка',
      detail: response.data.data.message,
      life: 3000
    })
  } else {
    setTimeout(checkUpdate, 10000)
  }
}

const emailValidator = email => {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
}

const openSharingDialog = (fileid) => {
  currentFileId.value = fileid
  // Очищаем поля при открытии диалога
  sharingType.value = null
  sharingRole.value = null
  sharingExpirationDate.value = null
  showSharingDialog.value = true
}

const changeSharingType = async (fileid, sharingType, sharingRole, expirationDate = null) => {
  // Валидация даты истечения
  if (expirationDate) {
    const selectedDate = new Date(expirationDate);
    if (isNaN(selectedDate.getTime())) {
      toast.add({
        severity: 'error',
        summary: 'Ошибка',
        detail: 'Некорректный формат даты',
        life: 3000
      })
      return
    }
    const now = new Date();
    if (selectedDate <= now) {
      toast.add({
        severity: 'error',
        summary: 'Ошибка',
        detail: 'Дата истечения должна быть в будущем',
        life: 3000
      })
      return
    }
  }

  const response = await axios.post(
    'https://ncht.bz/api/google/change-sharing-type',
    {
      fileId: fileid,
      sharingType: sharingType,
      sharingRole: sharingRole,
      expirationDate: expirationDate
    }
  )
  if (response.data.success) {
    getList()
    showSharingDialog.value = false
    // Очищаем поля
    sharingType.value = null
    sharingRole.value = null
    sharingExpirationDate.value = null
    toast.add({
      severity: 'success',
      summary: 'Успешно',
      detail: response.data.message,
      life: 3000
    })
  }
}

const openInGoogleDrive = (fileid) => {
  window.open(`https://drive.google.com/file/d/${fileid}/view`, '_blank')
}

const copyLink = (fileid) => {
  navigator.clipboard.writeText(`https://drive.google.com/file/d/${fileid}/view`)
  isCopied.value = true
  setTimeout(() => {
    isCopied.value = false
  }, 3000)
}

const onPageChange = (event) => {
  currentPage.value = event.page
}
</script>

<style scoped>
.flex {
  display: flex;
  align-items: center;
}

.flex-column {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.align-items-center {
  align-items: center;
}

.sharing-field {
  display: flex;
  align-items: center;
  justify-content: left;
  gap: 10px;
  margin-bottom: 10px;
}

.sharing-buttons {
  display: flex;
  align-items: center;
  justify-content: right;
  gap: 10px;
  margin-top: 10px;
}
</style>
